import React, { Component } from 'react';
import "./twoColumnImageGrid.css";

export default class extends Component {

  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }
  render() {
    var ratioImage= "images/square.png";
    if(this.props.ratio != "square"){
      ratioImage= "images/rectangle.png";
    }
    return (
      <div className={`row ${ this.props.direction }`}>
        <div className="small-12 medium-6">
          <div className="two-column-image-grid-left">
            <img className="full-width background-image-fill hover-grow" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.imageOne })`}} />
          </div>
        </div>
        <div className="small-12 medium-6">
          <div className="two-column-image-grid-right">
            <img className="full-width background-image-fill hover-grow" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.imageTwo })`}} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/twoColumnImageGrid/index.js